import { useEffect, useRef, useState } from 'react';

import { ProjectType } from '@cartwhl/common/types';
import Dropdown from '@cartwhl/ui/atoms/Dropdown';
import ChevronDropdownIcon from '@cartwhl/ui/icons/ChevronDropdownIcon';
import DiamondIcon from '@cartwhl/ui/icons/DiamondIcon';
import PenIcon from '@cartwhl/ui/icons/PenIcon';

import {
  animationGenerationStore,
  historyStore,
  projectStore,
  sceneSettingsStore,
} from 'stores';

export default function SessionDropdownMobile({
  hasPoseModeAccess,
  jobID,
  sessionName,
}: {
  hasPoseModeAccess: boolean;
  jobID: string;
  sessionName: string;
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(sessionName);

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setName(sessionName);
  }, [sessionName]);

  const handleBlur = async () => {
    setIsEditing(false);
    if (name.trim() !== '') {
      await historyStore.setSessionName(jobID, name);
      animationGenerationStore.setSessionName(jobID, name);
    } else {
      setName(sessionName);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleBlur();
    }
  };

  useEffect(() => {
    if (isEditing && inputRef.current && !inputRef.current.matches(':focus')) {
      inputRef.current.focus();
      inputRef.current.setSelectionRange(0, inputRef.current.value.length);
    }
  }, [inputRef.current, isEditing]);
  return (
    <>
      <div className="min-w-0 flex-auto lg:hidden">
        {isEditing ? (
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            ref={inputRef}
            className="font-display border-none bg-transparent text-left font-medium outline-hidden"
          />
        ) : (
          <Dropdown
            trigger={
              <button className="flex max-w-full cursor-pointer flex-row items-center gap-1 py-2">
                <span className="font-display truncate text-left font-medium">
                  {name}
                </span>
                <ChevronDropdownIcon className="flex-none" />
              </button>
            }
          >
            <Dropdown.Item
              icon={<PenIcon />}
              onClick={() => {
                setIsEditing(true);
              }}
            >
              Rename
            </Dropdown.Item>
            <Dropdown.Item
              icon={<DiamondIcon className="text-green-50" />}
              onClick={async () => {
                sceneSettingsStore.reset();
                const projectData = await projectStore.createNewProject(
                  ProjectType.MOTION,
                );
                if (projectData) {
                  window.location.href = `/motion/${projectData.projectID}`;
                }
              }}
            >
              New motion
            </Dropdown.Item>
            {hasPoseModeAccess && (
              <Dropdown.Item
                icon={<DiamondIcon className="text-violet" />}
                onClick={async () => {
                  sceneSettingsStore.reset();
                  const projectData = await projectStore.createNewProject(
                    ProjectType.POSE,
                  );
                  if (projectData) {
                    window.location.href = `/pose/${projectData.projectID}`;
                  }
                }}
              >
                New pose
              </Dropdown.Item>
            )}
          </Dropdown>
        )}
      </div>
    </>
  );
}
